import { ApiEnvironment } from '../../models/api-environment';

export class PartnerBundleEnvironment extends ApiEnvironment {
  get bundlesUrl() {
    return `${this.baseUrl}/api/v1/bundles`;
  }

  bundlesPartnerAccount(alias: string, accountId: string) {
    return `${this.baseUrl}/api/v1/bundles/partner/${alias}/account/${accountId}`;
  }

  apiKeysBundleCreateRequest(bundleId: number) {
    return `${this.baseUrl}/api/v1/apikeys/bundle/${bundleId}/create-request`;
  }

  override resolve(environment: unknown) {
    return environment instanceof PartnerBundleEnvironment ? environment : this;
  }
}

export const partnerBundleEnvironment = new PartnerBundleEnvironment();
